import  { Component } from 'react';
import FormIndividu from './form-individu';
import {RadioBox} from './radiobox';
class Enfants extends Component{
	constructor (props){
		super(props);

		this.state = {
			showForm : false,
			hasChild : false,
			showChildQuestions : this.props.hasEnfant,
			individus : this.props.individus,
			liste_enfants : {},
		};

		/* Initialisation liste enfants depuis liste individus */
		Object.keys(this.state.individus).forEach( (key)=>{
			if ( key !== 'conjoint' && key !== 'individu' && key !=='demandeur' ){
				this.state.liste_enfants[key] = this.state.individus[key];
			}
		})
	}

	/* Event Handlers*/
	changeHasChild = (value)=>{
		this.setState((oldState)=>{
			return { hasChild: JSON.parse(value)};
		});
	}

	newChildForm = (e)=> {
		this.setState( ({liste_enfants})=>{	
			let id_enfants = Object.keys(liste_enfants);
			let last_child_id = (id_enfants.length>0) ? parseInt(id_enfants[id_enfants.length-1].slice(-1)) : 0;
			return { 
				enfant_id : "enfant_"+(last_child_id + 1),
				showForm : true,
			}
		});
	}

	updateChildForm = (id)=> {
		this.setState( ()=>{
			return {
				enfant_id : id,
				showForm :true
			}
		});
	}

	deleteChild = (id)=>{
		this.setState ( ({liste_enfants})=>{
			delete liste_enfants[id];
			return {liste_enfants : liste_enfants}
		})
	}
	
	/* Views */
	questionsEnfants  = () => {
		return<>
			{  ( this.state.showForm ) ?
				( this.childForm() )
				: <div>
					{ this.blocListeEnfants() }
					<button onClick={this.newChildForm} className="bouton-ajout-enfant"> <i className="fa fa-plus"></i> </button>
					
				</div>
			}
		</>;
	}

	blocListeEnfants = () => {
		const mapNationalite = {
            'FR' : 'Française' ,
            'EEE - UE - Suisse' :'EEE - UE - Suisse' ,
            'Hors UE' :'Hors UE' 
        };
		return <div className ="bloc-liste-enfants">
			{Object.keys(this.state.liste_enfants).map( (id)=>{
				return <div className="bloc-enfant">
					<div className="head">
						<h2>{this.state.liste_enfants[id].name}</h2>
						<div className="enfant-info">
							<p> Agé.e de <b>{this.state.liste_enfants[id].age} an.s</b></p>
							<p> Nationalité : <i><b>{mapNationalite[this.state.liste_enfants[id].nationalite]}</b></i></p>
						</div>
					</div>
					<div className="body">
						<button className="btn update-btn" onClick={(e)=>(this.updateChildForm(id))}><i className="fa fa-pencil"></i>modifier</button>
						<button className="btn delete-btn" onClick={(e)=>(this.deleteChild(id))}><i className="fa fa-times"></i>supprimer</button>
					</div>
				</div>
			})}
		</div>
	}

	questionNombreEnfants = () => {
		return <div className="question">
            <div className="question_enfants">
	            <RadioBox
	            	name="enfant"
	                options={{"Oui":true , "Non":false}}
	                handler={this.changeHasChild}
	                defaultValue={this.state.hasChild}
	            >
	                <h3>Avez-vous des enfants à charge ?</h3>
	            </RadioBox>
            </div>
		</div>
	}

	handleChangeDataEnfant = (data)=> {
		this.setState( ({liste_enfants , enfant_id})=>{
			liste_enfants[enfant_id] = data;
			return {
				liste_enfants : liste_enfants,
				showForm : false
			};
		});
	}

	formulaireEnfant  = ()=>{
		const childIndex = (this.state.enfant_id).slice(-1);
		const name = "Votre "+ childIndex+ ((childIndex > 1) ?'eme':'er') + ' enfant'  ;
		return <FormIndividu saveData={this.handleChangeDataEnfant}  
			dataIndividu={this.state.liste_enfants[this.state.enfant_id]}
			name={name}
			enfant={true} />
	}

	next =()=>{
		const data = {
			'individus' : {} ,
			'enfantSaisi':true
		};

		Object.keys(this.state.liste_enfants).forEach((enfant)=>{
			data.individus[enfant]  = this.state.liste_enfants[enfant]
		});

		if ( ! this.state.hasChild  ) {
			
			this.props.validateStep(data);
		} else {
			if (!this.state.showChildQuestions ) {
				this.setState(()=>{
					return {showChildQuestions : true}
				})
			}else {
				this.props.validateStep(data);
			}
		}
	}

	previous = () => {
		this.props.previousStep();
	}

	restart = ()=> {
		this.props.restart();
	}

	render() {
		return <div className="step-inner-container">
			<p className="step-title"><strong>Mes enfants à charge</strong></p> 
			{( !this.state.showForm) ?
				<>
					{ (!this.state.showChildQuestions) ?
						this.questionNombreEnfants()
						:this.questionsEnfants()
					}
					<div className="button-container">
						<button onClick={this.next}>Valider</button>
					</div>
					<div className="button-container previous">
						<button onClick={this.restart}>  Recommencer </button>
						
					</div>
				</>
				: this.formulaireEnfant()
			}
		</div>;
	}
}

export default Enfants ;
